// header fixed on scroll
$(document).ready(function () {
  $(".my-cart").click(function () {
    updateCartDrawer();
    $(".cart-box").addClass("cart-display");
  });
  $(".cart-box .fa-times").click(function () {
    $(".cart-box").removeClass("cart-display");
  });

  $(".tab-menu-open").click(function () {
    $(".nav-menu").addClass("tab-menu-display");
    $(".nav-menu").removeClass("nav-menu-none");
    $("body").addClass("sm-body-scrollbar");
  });

  $(".cross-icon").click(function () {
    $(".nav-menu").addClass("nav-menu-none");
    $(".nav-menu").removeClass("tab-menu-display");
    $("body").removeClass("sm-body-scrollbar");
  });
  
  $(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
      $("#scroll").fadeIn();
    } else {
      $("#scroll").fadeOut();
    }
  });
  $("#scroll").click(function () {
    $("html, body").animate({ scrollTop: 0 }, 600);
    return false;
  });
  $(".searchbar").click(function () {
        document.getElementById("searchBlockSmall").style.width = "100%";
        var overlay = jQuery('<div id="overlay"> </div>');

        overlay.appendTo('.page-container');
        $("#searchBlockSmall").css('z-index','22333');
  });
  $(document).mouseup(function(e) {
      var container = $(".cart-box,.my-cart");
      
      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) 
      {
          $(".cart-box").removeClass("cart-display");
      }
  });

  //------------------------------- less & more features js - PDP Page------------------------------- 
  $(".toggle-more").click(function() {
    var elem = $(".toggle-more").text();
    if (elem == "More Features") {
      //Stuff to do when btn is in the read more state
      $(".toggle-more").text("Less Features");
      $("#pdp-feature-list ul li:gt(2)").slideDown();
    } else {
      //Stuff to do when btn is in the read less state
      $(".toggle-more").text("More Features");
      $("#pdp-feature-list ul li:gt(2)").slideUp();
    }
  });
  if ($('#pdp-feature-list > ul > li').length > 3) {
    $('.toggle-more').show();
  }
  else{
    $('.toggle-more').hide();
  }
      
  $('.main-img-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    arrows: true,
    fade: true,
    autoplay: false,adaptiveHeight: true,
    autoplaySpeed: 4000,
    speed: 300,
    lazyLoad: 'ondemand',
    asNavFor: '.thumb-nav'
  });
  // Thumbnail/alternates slider for product page
  $('.thumb-nav').slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    infinite: true,
    centerPadding: '0px',
    asNavFor: '.main-img-slider',
    dots: false,
    centerMode: false,
    draggable: true,
    speed: 200,
    focusOnSelect: true,
  });

  var preloader = document.getElementById('loader');

  $(".cross-icon-mobile").click(function () {
      $('.body-event').removeClass('mm-wrapper--opened');
      $('#menu').removeClass('mm-menu--opened');
    });
    $('.body-event').on('click', '#mm-0', function () {
      $('.body-event').removeClass('mm-wrapper--opened');
      $('#menu').removeClass('mm-menu--opened');
    });
});

document.addEventListener('DOMContentLoaded', () => {
      var API = new Mmenu("#menu", {
      extensions: ["theme-light", "position-front", "position-left" , "border-none"],
      navbar: { title: "Menu" },
      navbars: [true],
      offCanvas: {
      page: {
      nodetype: "section"
      }
      }
      },
      {
      searchfield: { clear: true }
      });
    });
    
   
  
// search open block
function openNav() {
  document.getElementById("searchBlock").style.width = "100%";
}

function closeNav() {
  document.getElementById("searchBlockSmall").style.width = "0";
  document.getElementById("searchBlock").style.width = "0";
  $('#overlay').remove();
}

//quantity counter code
$(document).on("click", ".ajax-cart-item__minus-quantity", function (e) {
  decrementValue(e);
});
$(document).on("click", ".ajax-cart-item__add-quantity", function (e) {
  incrementValue(e);
});
$(document).on("click", ".cart-dropdown-remove .remove", function (e) {
  setTimeout(function() {
    updateCartDrawer();
  }, 1000);
});

function incrementValue(e) {
  e.preventDefault();
  var parent = $(e.target).closest("div");
  var currentVal = parseInt(parent.find(".ajax-cart-item__input-quantity").val(), 10);
  var currentVariant = $(e.target).attr("data-variant");

  $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
      data: {
          quantity: currentVal + 1,
          id: currentVariant
      },
      success: function(cart) {
        setTimeout(function() {
          updateCartDrawer();
        }, 1000);
      }
  });
  
  if (!isNaN(currentVal)) {
    parent.find(".ajax-cart-item__input-quantity").val(currentVal + 1);
  } else {
    parent.find(".ajax-cart-item__input-quantity").val(0);
  }
}
function decrementValue(e) {
  e.preventDefault();
  
  var parent = $(e.target).closest("div");
  var currentVal = parseInt(parent.find(".ajax-cart-item__input-quantity").val(), 10);
  var currentVariant = $(e.target).attr("data-variant");

  $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
      data: {
          quantity: currentVal - 1,
          id: currentVariant
      },
      success: function(cart) {
        setTimeout(function() {
          updateCartDrawer();
        }, 1000);
      }
  });
  
  if (!isNaN(currentVal) && currentVal > 0) {
    parent.find(".ajax-cart-item__input-quantity").val(currentVal - 1);
  } else {
    parent.find(".ajax-cart-item__input-quantity").val(0);
  }
}

$(document).ready(function () {
  $(".accordion-button").click(function () {
    $(this).addClass("Hello");
    $(this).toggleClass("bluecolor");
  });
});

// filter for mobile device
function openFilter() {
  document.getElementById("filterOption").style.width = "100%";
}

function closeFilter() {
  document.getElementById("filterOption").style.width = "0";
}

//start js code for desktop menu as samsung
 function handleClose(id) {
    document.getElementById(id).style.display = "none";
}
function hidemenu(ele){
  ele.style.display = "none";
  $(".list-category").find("li .right-arrow").addClass("close");
  
  var id_2 = document.getElementById(ele);
  $(id_2).find('.main_menu .sub_menu_nav').first().addClass('active addActiveColor');
  $('.active').find('.backpacks-list').addClass('open default-opacity');
  $('.active').find('.backpacks-list').removeClass('close');
  $('.active').find('.right-arrow').addClass("-arrow open");
  $('.active').find('.right-arrow').removeClass("close");      
  $('.imageelementmenu').addClass("close");
}
function handleHover(id) {
  $(".backpacks-value").addClass("default-opacity");
  $(".dropdown-content").css("display", "none");
  
  var main_id = document.getElementById(id);
  $(main_id).stop().fadeIn("fast");
  
  if($(main_id).find('.main_menu .sub_menu_nav').length > 0){
    $(main_id).find('.main_menu .sub_menu_nav').first().addClass('active addActiveColor');
    $('.active').find('.backpacks-list').addClass('open default-opacity');
    
    $('.active').find('.right-arrow').addClass("-arrow open");
    $('.active').find('.right-arrow').removeClass("close");
    
    var main_active_image = $(main_id).find('.main_menu .sub_menu_nav').first().addClass('active addActiveColor');
    $(main_active_image).parent().siblings('.image-container').find('.imageelementmenu').first().removeClass('close').addClass('open');
  }
}

function openSubMenu(id) {
    $(".default-opacity").removeClass("default-opacity");
    $(".right-arrow").addClass(id + "-arrow close");
    $("#" + id + "-arrow").removeClass(id + "-arrow close");
    $("#" + id + "-arrow").addClass(id + "-arrow open");
    $("._listImage").addClass(id + "-value close");
    $("._listItem").addClass(id + "-value close");
    $("#" + id + "-list").removeClass(id + "-value close");
    $("#" + id + "-list").addClass(id + "-value open");
    $(".list-category").find(".addActiveColor").removeClass("addActiveColor");
    $("#" + id).removeClass("addActiveColor");
    $("#" + id).addClass("addActiveColor");
    $(".list-category").find("li").removeClass("addActiveColor");
    $(".list-category").find("li:last-child").removeClass("addActiveColor");
    $("#" + id + "-arrow").addClass(id + "-arrow open");
    $("#" + id + "-arrow").removeClass(id + "-arrow open");
  
    $('.imageelementmenu').addClass("close");
    $("#"+id+"-image").removeClass("close");
    $("#"+id+"-image").addClass("open");
}

function closeSubMenu(id, id2) {
    $("#backpacks-list").addClass("default-opacity");
}

window.addEventListener('fs-custom-events-product-added-to-cart', (e) => {updateCartDrawer();});

  // ------------------------------slick slider js------
  var maxHeight = -1;
  $('.slick-slide').each(function() {
    if ($(this).height() > maxHeight) {
      maxHeight = $(this).height();
    }
  });
  $('.slick-slide').each(function() {
    if ($(this).height() < maxHeight) {
      $(this).css('margin', Math.ceil((maxHeight-$(this).height())/2) + 'px 0');
    }
  });
  
  $(function () {
    $('.lazy').Lazy();
  }); 

// ----------------------------------------- Dropdown menu---------------------
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.dropdown-menu').forEach(function (element) {
    element.addEventListener('mouseover', function (e) {
      e.stopPropagation();
    });
  })

});

document.addEventListener("shopify:section:load", function(event) {
  $('.lazy').Lazy();
  $(".slick", ".vertical-slider").slick({
    vertical: true,
    verticalSwiping: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    dots: false
  });
  document.addEventListener('DOMContentLoaded', () => {
    var API = new Mmenu("#menu", {
    extensions: ["theme-light", "position-front", "position-left" , "border-none"],
    navbar: { title: "Menu" },
    navbars: [true],
    offCanvas: {
    page: {
    nodetype: "section"
    }
    }
    },
    {
    searchfield: { clear: true }
    });
});
});